import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function Container(props) {
  return React.Children.toArray(props.children).map(child => {
    if (! /*#__PURE__*/React.isValidElement(child)) return null;
    return /*#__PURE__*/React.cloneElement(child, _extends({}, props, child.props));
  });
}
Container.displayName = 'Container';